import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Title from "../Title";
import Text from "../Text";

const StepTitle = ({ className, textClassName, title, step }) => (
  <Title className={classNames("mydpd-card-step-title", className)}>
    {step && (
      <div className={classNames("mydpd-card-step-circle")}>
        <span>{step}</span>
      </div>
    )}
    <Text className={classNames("mydpd-card-step-text", textClassName)}>
      {title}
    </Text>
  </Title>
);

StepTitle.defaultProps = {
  className: "",
  textClassName: "",
};

StepTitle.propTypes = {
  className: PropTypes.string,
  textClassName: PropTypes.string,
  title: PropTypes.string,
  step: PropTypes.number,
};

export default StepTitle;
